import { v4 } from 'uuid';
import { TableSettings } from '../TableSettings';
import { EntityType } from '../../comment';
import { translate } from '../../translation/Translator';

export const ProductTableSettingsColumn = {
  productName: 'productName',
  productNumber: 'productNumber',
  quantity: 'quantity',
} as const;

export type ProductTableSettingsColumn = (typeof ProductTableSettingsColumn)[keyof typeof ProductTableSettingsColumn];

export class ProductTableSettings {
  static default(companyId: string) {
    return new TableSettings<ProductTableSettingsColumn>({
      id: v4(),
      companyId,
      type: EntityType.product,
      columns: [
        {
          index: 0,
          column: ProductTableSettingsColumn.productName,
          label: translate({ key: ProductTableSettingsColumn.productName }),
        },
        {
          index: 1,
          column: ProductTableSettingsColumn.productNumber,
          label: translate({ key: ProductTableSettingsColumn.productNumber }),
        },
        {
          index: 2,
          column: ProductTableSettingsColumn.quantity,
          label: translate({ key: ProductTableSettingsColumn.quantity }),
        },
      ],
    });
  }
}
